import API from 'api/hallomart';

/**
 * Constants
 */

export const FETCH_TRANSACTIONS = 'transactions/TRANSACTIONS';
export const FETCH_TRANSACTIONS_OK = 'transactions/TRANSACTIONS_OK';
export const FETCH_TRANSACTIONS_FAILED = 'transactions/TRANSACTIONS_FAILED';

/**
 * Action Creators
 */

export function fetchTransactions(args = {}) {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_TRANSACTIONS });
      const transactions = await API.getTransactionHistory(args);
      dispatch({
        type: FETCH_TRANSACTIONS_OK,
        payload: transactions.data,
        totalPages: parseInt(transactions.headers['x-wp-totalpages'], 10),
      });
    } catch (err) {
      dispatch({ type: FETCH_TRANSACTIONS_FAILED, error: err.response || err.message });
    }
  };
}

/**
 * Reducers
 */

const initialState = {
  isLoading: false,
  error: false,
  errors: {},
  transactions: [],
  totalPages: 1,
};

export default function transactions(state = initialState, action) {
  switch (action.type) {
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        error: false,
        errors: {},
        isLoading: true,
      };

    case FETCH_TRANSACTIONS_OK:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactions: action.payload,
        totalPages: action.totalPages,
      };

    case FETCH_TRANSACTIONS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: true,
        errors: action.error,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/transactions.js